import Form from './form'

export default {
  svg: 'phone',
  label: 'Dial',
  type: 'voice',
  action: 'dial',
  form: Form
}
